// apps/web/src/store/index.ts
import { configureStore } from '@reduxjs/toolkit';
import financialReducer from './financialSlice';
import scenariosReducer from './scenariosSlice';
import settingsReducer from './settingsSlice';
import economyReducer from './economySlice';
import xpReducer from './xpSlice';
import badgesReducer from './badgesSlice';
import uiReducer from './uiSlice';
import { localStorageMiddleware } from './localStorageMiddleware';

export const store = configureStore({
	reducer: {
		financial: financialReducer,
		scenarios: scenariosReducer,
		settings: settingsReducer,
		economy: economyReducer,
		xp: xpReducer,
		badges: badgesReducer,
		// V7 — transient UI state (Money Flow → Investments handoff). Not
		// persisted: the localStorage middleware only serializes financial/*.
		ui: uiReducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware().concat(localStorageMiddleware),
});

export type { RootState } from './types';
export type AppDispatch = typeof store.dispatch;
